import { Box, Dialog, DialogTitle, SxProps, Theme } from '@mui/material'
import { Help } from '@mui/icons-material'
import { Trans, useTranslation } from 'react-i18next'
import { useState } from 'react'
import { Button } from './Button'

export interface HelpTitleProps {
  title: string
  code: string
  sx?: SxProps<Theme>
}

export function HelpTitle(props: HelpTitleProps): React.ReactElement {
  const { title, code, sx } = props
  const [opened, setOpened] = useState(false)
  const { t } = useTranslation()
  const text = t(`Help-${code}`)

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', pr: 1, ...sx }}>
      <Box>{title}</Box>
      <Help sx={{ marginLeft: 'auto', cursor: 'pointer', color: 'success.dark' }} onClick={() => setOpened(true)}/>

      <Dialog open={!!opened} onClose={() => setOpened(false)}>
        <DialogTitle sx={{ backgroundColor: 'success.dark' }}><Trans>Help</Trans></DialogTitle>
        <Box sx={{ p: 2 }}>
          <Box sx={{ p: 2 }}>

              {text.split('\n').map((line, idx) => <Box key={idx} sx={{ mb: 1.5 }}>{line}</Box>)}

          </Box>
          <Button sx={{ ml: 2, my: 1 }} color="primary" onClick={() => setOpened(false)}><Trans>OK</Trans></Button>
        </Box>
      </Dialog>

    </Box>
  )
}
